export const Chat = [
  {
    path: '/chats/:app_module_id',
    name: 'chats.index',
    component: () => import('@/pages/Chat/ChatModule')
  },
  {
    path: '/chats/:app_module_id/archive',
    name: 'chats.archive',
    component: () => import('@/pages/Chat/ChatArchive')
  },
  {
    path: '/chats/:app_module_id/archive/:chat_type/:id',
    name: 'chats.archive.item',
    component: () => import('@/pages/Chat/ChatPage')
  },
  {
    path: '/chats/:app_module_id/:chat_type/:id',
    name: 'chats.item',
    component: () => import('@/pages/Chat/ChatPage')
  }
]
